module.exports = ".badge-pill {\n  padding: 10px;\n  font-size: 1em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/contratos/modal-nuevo-convenio/modal-nuevo-convenio.component.scss
// module id = ./src/app/components/contratos/modal-nuevo-convenio/modal-nuevo-convenio.component.scss
// module chunks = main